
import ManaIcon from "@/shared/ui/Icon/svg/ManaIcon.vue";
import { defineComponent } from "vue";
import { useCharactersStore } from "@/app/store/CharacterStore";
import { storeToRefs } from "pinia";

export default defineComponent({
	name: "ManaBar",
	components: { ManaIcon },
	setup() {
		const store = useCharactersStore();

		const { characters, current, maxMana } = storeToRefs(store);

		return {
			characters,
			current,
			maxMana,
		};
	},
	computed: {
		percent(): number {
			return (
				(this.characters[this.current].mana.current / this.maxMana) *
				100
			);
		},
		bg(): string {
			return `linear-gradient(90deg, #181818 0%, #181818 ${this.percent}%, transparent ${this.percent}%)`;
		},
	},
});
